export const ENV_KEYS = {
  DEV: 'development',
};

const S3_BUCKETS = {
  STAGING_PREVIEW: 'https://woobles-staging-preview.s3.amazonaws.com',
  STAGING_PUBLIC: 'https://woobles-staging-public.s3.amazonaws.com',
  PROD_PREVIEW: 'https://woobles-prod-preview.s3.amazonaws.com',
  PROD_PUBLIC: 'https://woobles-prod-public.s3.amazonaws.com',
};

export const VIDEO_BASES = {
  PREVIEW: S3_BUCKETS.PROD_PREVIEW,
  PROD: 'https://videos.thewoobles.com',
};

const ENVS = {
  DEV: {
    DEV: true,
    S3_ROOT: S3_BUCKETS.PROD_PUBLIC,
    API_ROOT: 'https://0kty8hp57j.execute-api.us-east-1.amazonaws.com/staging',
  },
  STAGING: {
    S3_ROOT: '',
    API_ROOT: 'https://0kty8hp57j.execute-api.us-east-1.amazonaws.com/staging',
  },
  PROD: {
    S3_ROOT: '',
    API_ROOT: 'https://c7k2z327be.execute-api.us-east-1.amazonaws.com/prod',
  },
};

let env = ENVS.PROD;

if (process.env.NODE_ENV === ENV_KEYS.DEV) {
  env = ENVS.DEV;
} else if (window.location.host.startsWith('woobles-staging')) {
  env = ENVS.STAGING;
}

export const isPreview = () => {
  return window.location.hostname.includes('preview');
};

export const ENV = env;
